type Tone = "accent" | "success" | "warning" | "danger" | "neutral";

type Props = {
  children: React.ReactNode;
  tone?: Tone;
  icon?: React.ReactNode;
  className?: string;
};

const tones: Record<Tone, string> = {
  // Solid, filled pills (dark text on the brand color).
  accent: "bg-accent text-ink",
  success: "bg-raytio-green text-ink",
  warning: "bg-raytio-yellow text-ink",
  danger: "bg-raytio-red text-ink",
  neutral: "bg-surface-elevated text-text-medium",
};

/** Small uppercase pill (verification badges, ISO tags, etc.). */
export const Badge = ({
  children,
  tone = "accent",
  icon,
  className = "",
}: Props) => (
  <span
    className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wide ${tones[tone]} ${className}`}
  >
    {icon}
    {children}
  </span>
);
